"use client";

import type { UseOpenApiQueryOptions } from "../../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../request/hooks/openApi/useOpenApiQuery";
import { communityEventRequestConfig } from "./communityEventRequestConfig";
import { keyCommunityEvent } from "./keyCommunityEvent";

export type UseRequestCommunityEventProps = Omit<
  UseOpenApiQueryOptions<"/community_events/{encoded_event_occurrence_id}">,
  "urlBackendPath"
> & { communityId: string | number; eventId: string };

export const useRequestCommunityEvent = ({
  communityId,
  eventId,
  ...props
}: UseRequestCommunityEventProps) => ({
  query: useOpenApiQuery({
    ...props,
    ...communityEventRequestConfig(eventId),
    queryKey: keyCommunityEvent({ communityId, eventId }),
  }),
});
